module.exports = __webpack_public_path__ + "1563a8c8fbc09b9c75842f4157ca370e.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/tomhorn/assets/151.png
// module id = 1746
// module chunks = 2